import React, { useEffect, useState } from "react";
import Socialicons from "../components/Socialicons";
import Layout from "../components/Layout";
import { useLanguage } from '../context/LanguageContext';
import { Fade, Bounce } from 'react-awesome-reveal';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

function Home(){
  const { d } = useLanguage();
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const paramConfig = {
    fpsLimit: 48,
    interactivity: {
        events: {
            onClick: {
                enable: true,
                mode: "bounce",
            },
            onHover: {
                enable: true,
                mode: "repulse",
            },
            resize: true,
        },
        modes: {
            push: {
                quantity: 4,
            },
            repulse: {
                distance: 150,
                duration: 0.4,
            },
        },
    },
    particles: {
        collisions: {
          absorb: {
            speed: 2
          },
          bounce: {
            horizontal: {
              value: 1
            },
            vertical: {
              value: 1
            }
          },
          enable: true,
          maxSpeed: 3,
          mode: "bounce",
          overlap: {
            enable: true,
            retries: 0
          }
        },
        color: {
            value: "#ffffff",
        },
        links: {
            color: "#ffffff",
            distance: 150,
            enable: true,
            opacity: 0.1,
            width: 1,
        },
        move: {
            direction: "outside",
            enable: true,
            outModes: {
                default: "bounce",
            },
            random: true,
            speed: 2,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 800,
            },
            value: 80,
        },
        opacity: {
            value: 0.2,
        },
        shape: {
            type: "circle",
        },
        size: {
            value: { min: 5, max: 10 },
        },
    },
    detectRetina: true,
  };

  return (
    <Layout>
      {init && <Particles id="tsparticles" className="mi-home-particle" options={paramConfig} />}
      <div className="mi-home-area mi-padding-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-12">
              <div className="mi-home-content">
                <Fade cascade damping={0.2}>
                  <h1>{d.information.hiContent}&nbsp;<span className="color-theme">{d.information.name}</span></h1>
                  <p>{d.information.aboutContent}</p>
                </Fade>
                <Bounce wait={50} delay={200}>
                  <Socialicons />
                </Bounce>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
